<template>
  <div class="field">
    <label :class="isRequired ? 'req' : ''">{{ label }}</label>
    <div class="select-field">
<!--  onChange: ($event) => {$emit('update:modelValue', $event.target.value); $emit('onChange', $event.target.value);}    :value="modelValue"-->
      <select v-model="selectValue" :disabled="inputValue.length > 0" v-bind="{
          ...$attrs
          }" >
        <option disabled value="">Выберите значение</option>
        <template v-for="(value,index) in values" :key="index">
          <option :value="value.value" :selected="value === modelValue">{{ value.label }}</option>
        </template>
        <option value="Другое" :selected="selectValue === 'Другое'">Другое</option>
      </select>
    </div>
    <div v-if="selectValue === 'Другое'" class="other_field">
      <input type="text" :placeholder="otherPlaceholder" @change="onInputChange" v-model="inputValue">
    </div>
  </div>

</template>

<script>
export default {
  name: "BaseSelectWithOther",
  data() {
    return {
      selectValue: '',
      inputValue: '',
      isInitialized: false
    }
  },
  props: [
    'modelValue',
    'label',
    'values',
    'otherPlaceholder',
    'isRequired'
  ],
  mounted() {
    const isInValues = this.values.some((obj) => {
      return obj.value !== 'Другое' && obj.value === this.modelValue;
    });

    if (isInValues) {
      this.selectValue = this.modelValue;
    } else {
      this.inputValue = this.modelValue;
    }
  },
  methods: {
    onInputChange(val) {
      this.$emit('onChange', val.target.value)
    }
  },
  computed: {},
  watch: {
    selectValue: {
      handler(val) {
        if (this.isInitialized && val !== 'Другое') {
          this.$emit('update:modelValue', val); this.$emit('onChange', val)
        }
        this.isInitialized = true
      },
      immediate: false
    },
    inputValue(val) {
      if (val.length > 0) {
        this.selectValue = 'Другое'
      }
      this.$emit('update:modelValue', val);
    }
  }
}
</script>

<style scoped>
.other_field label {
  margin-top: 15px;
  margin-bottom: 0;
  font-size: 14px;
}
  .other_field input {
    max-width: 570px;
  }
</style>